import React from 'react';
import styles from '../RegionsCard/RegionsCard.css';
import FieldThumbnail from '../../../components/FieldThumbnail/FieldThumbnail';
import { Activity } from '../../../types/Activity'
import { GeoJson } from '../../../types/GeoJson'
import { toDateString } from '../../../utils/date';

export interface RegionReportCardProps {
  onRegionClick: (activity: Activity) => void;
  activity: Activity;
  geoJson: GeoJson;
  locale: string;
}

export const RegionReportCard = (props: RegionReportCardProps) => (
  <div
    className={styles.regionRow}
    data-test-id='region-container'
    key={`regions-card-${props.activity.id}`}
    onClick={() => props.onRegionClick(props.activity)}
    onKeyDown={(e) => e.key === 'Enter' && props.onRegionClick(props.activity)}
    role="button"
    tabIndex={0}>
    <div className={styles.thumbnailWrapper} data-test-id='region-thumbnail'>
      <FieldThumbnail
        fillColor="#FFF"
        geoJson={props.geoJson}
        regionColor={props.activity.color}
        regionFillOpacity={0.2} />
    </div>
    <div className={styles.regionContent}>
      <div className={styles.regionTitle} data-test-id="region-title">
        {props.activity.title || '-'}
      </div>
      <time className={styles.regionScoutedAt} data-test-id="region-scoutedAt">
        {toDateString(props.activity.scoutedAt, props.locale)}
      </time>
    </div>
  </div>
);
